'use client';
import Image from 'next/image';

import Placeholder from '../../public/images/authors/placeholder.svg';
import Icon from '../../public/images/authors/icon.svg';

type Props = {
    author: any;
    withIcon?: boolean;
};

export default function AuthorImage({ author, withIcon = true }: Props) {
    return (
        <>
            {author.avatar?.thumbnail ? (
                <Image
                    className="object-cover"
                    alt={author.name}
                    src={author.avatar.thumbnail}
                    placeholder={author.avatar.placeholder}
                    fill
                />
            ) : (
                <div className="bg-primary">
                    <Placeholder />
                </div>
            )}
            {withIcon && (
                <div className="bg-light-grey absolute -bottom-6 right-2 h-14 w-14 rounded-full">
                    <Icon className="m-3" />
                </div>
            )}
        </>
    );
}
